import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectMultipleEmployeeOrTeamAsyncConnected } from '../../../apps/dashboard/components/Selects/SelectMultipleEmployeeOrTeamAsyncConnected';
import { EmployeeOrTeamOption } from '../../../apps/dashboard/components/Selects/EmployeeOrTeamOptionLabel';
import InputError from '../../form/InputError';
import { getError } from '../utils';

export type Props = {
  name: string;
};

export const SelectMultipleEmployeeOrTeamConnectedControlled: React.FC<
  React.PropsWithChildren<Props>
> = ({ name }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<Record<string, EmployeeOrTeamOption[]>>();
  const error = getError(name, errors);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <SelectMultipleEmployeeOrTeamAsyncConnected
            values={field.value ?? []}
            onChange={field.onChange}
            className={error ? 'is-invalid' : ''}
            error={!!error}
          />
        )}
      />
      <InputError error={error} />
    </>
  );
};
